module.exports = __webpack_public_path__ + "img/3-2.b7a183b1.jpg";